import { RoutesConfiguration } from '@components/RouterOutlet';
import { MenuRoutePaths } from './routesPaths';
import { MenuRouteConfig } from './Menu/MenuRoute';
import { UserRouteConfig } from './User/UserRoute';
import { AboutRouteConfig } from './About/AboutRoute';
import { ProfileRouteConfig } from './Profile/ProfileRoute';
import { AuthorRouteConfig } from './Author/AuthorRoute';
import { SerieRouteConfig } from './Serie/SerieRoute';
import { BookRouteConfig } from './Book/BookRoute';

export const appRedirectConfig = {
  from: '/',
  to: MenuRoutePaths.menuRoot,
};

export const appRoutesConfig: RoutesConfiguration = [
  ...MenuRouteConfig,
  ...UserRouteConfig,
  ...AboutRouteConfig,
  ...ProfileRouteConfig,
  ...AuthorRouteConfig,
  ...SerieRouteConfig,
  ...BookRouteConfig,
];
